import { MarketConfig } from '../../types/markets/MarketConfig';

export default new MarketConfig(
  'en_ZA',
  {
    fdidYouMean: false,
    ffacetNavigation: false,
    fdomainSuggestions: false,
    fvideo: false,
    fCommerceCarrossel: false,
    resultTiles: false,
    dealerWidget: false,
    frelatedsearch: false,
  },
  {
    fssInputCategory: true,
  },
  '71381fec-69cb-41ce-9e2f-8e41c2a7d7fa',
  ''
);
